import React from 'react';
import { DialogDefault } from '../../../shared/components/dialog/DialogDefault';
import { CommentStatuses } from '../comment-types';
import { useCallAction } from '@cobuildlab/react-simple-state';
import {
  changeMultipleCommentStatus,
  changeMultipleRepliesStatus,
} from '../comment-actions';
import { openSnackbarAction } from '../../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../../shared/components/snackbar/snackbar-types';

type ChangeCommentStatusDialogProps = {
  open: boolean;
  search?: string;
  comments?: number[];
  isReplies?: boolean;
  status: CommentStatuses | undefined;
  onHandleClose: () => void;
  onSuccess: () => void;
  warningMessage?: string;
};
export const ChangeMultipleCommentStatusDialog: React.FC<
  ChangeCommentStatusDialogProps
> = ({
  open,
  onHandleClose,
  comments,
  search,
  status,
  onSuccess,
  isReplies = false,
  warningMessage,
}) => {
  const [callAction, loading] = useCallAction(changeMultipleCommentStatus, {
    onCompleted: (data) => {
      onHandleClose();
      onSuccess();
      openSnackbarAction(
        `Se ${data.comments?.count !== 0 ? 'aprobó ' + data.comments?.count : 'rechazó ' + data.comments?.count} comentarios con éxito.`,
        TypeMessage.SUCCESS,
      );
    },
    onError: () => {
      openSnackbarAction(
        'Tenemos problemas para procesar tu peticion',
        TypeMessage.ERROR,
      );
    },
  });

  const [callReplyAction, loadingReply] = useCallAction(
    changeMultipleRepliesStatus,
    {
      onCompleted: (data) => {
        onHandleClose();
        onSuccess();
        openSnackbarAction(
          `Se ${data.comments?.count !== 0 ? 'aprobó ' + data.comments?.count : 'rechazó ' + data.comments?.count} respuestas con éxito.`,
          TypeMessage.SUCCESS,
        );
      },
      onError: () => {
        openSnackbarAction(
          'Tenemos problemas para procesar la petición',
          TypeMessage.ERROR,
        );
      },
    },
  );

  return (
    <DialogDefault
      title="Cambiar estado multiples comentarios o respuestas"
      isOpen={open}
      handleClose={onHandleClose}
      isLoading={loading || loadingReply}
      handleSuccess={() => {
        if (isReplies) {
          callReplyAction(status, search, comments);
        } else {
          callAction(status, search, comments);
        }
      }}
      showActions
    >
      {warningMessage}
    </DialogDefault>
  );
};
